/**
 * Vue mixin for common client device related functionality.
 * @author bmk11u
 */

export default {
  data () {
    return {
      os: 'Other'
    }
  },
  mounted () {
    let agent = navigator.userAgent
    if (agent.indexOf('iPad') > -1 || agent.indexOf('iPhone') > -1) {
      this.os = 'iOS'
    } else if (agent.indexOf('Android') > -1) {
      this.os = 'Android'
    } else if (agent.indexOf('Windows') > -1) {
      this.os = 'Windows'
    }
  }
}
